Customer.Ticket ||= {}

class Customer.Ticket.ScheduleView extends Backbone.View
  newScheduleTemplate: JST['backbone/templates/customer/ticket/new_schedule']
  editScheduletemplate: JST['backbone/templates/customer/ticket/edit_schedule']

  events :
    'click #set-new-schedule': 'onClickSetNewAppointment'
    'click #set-updated-schedule': 'onClickSetUpdatedAppointment'
    'click #delete-schedule': 'onClickDeleteAppointment'
    'click #cancel-new-schedule': 'onClickCancelAppointment'
    'click #cancel-edit-schedule': 'onClickCancelAppointment'
    'change #ticket-schedule-on': 'onChangeTicketSchedule'

  initialize: (options = {}) ->
    @ticket = options.ticket
    @defaultMinutesForTicketsScheduler = options.defaultMinutesForTicketsScheduler

  renderNewSchedule: ->
    @$el.html(@newScheduleTemplate(@))
    @initializeNewScheduleModal()
    @initializeDatepicker(moment().add(@defaultMinutesForTicketsScheduler, 'minutes').format('HH:mm'))
    @trigger('disable:schedule')
    @

  renderEditSchedule: ->
    @$el.html(@editScheduletemplate(@))
    @initializeEditScheduleModal()
    @initializeDatepicker(moment(@ticket.get('userAppointment').date).format('HH:mm'))
    @trigger('disable:schedule')
    @

  initializeNewScheduleModal: ->
    @$el.find('#ticket-new-schedule').on('shown.bs.modal', ->
      # Without this line, the hours and minutes cannot be adjusted with the keyboard arrows.
      $(document).off('focusin.modal')
    )
    @$el.find('#ticket-new-schedule').modal()

  initializeEditScheduleModal: ->
    @$el.find('#ticket-schedule-edit').on('shown.bs.modal', ->
      # without this line, the hours and minutes cannot be adjusted with the keyboard arrows.
      $(document).off('focusin.modal')
    )
    @$el.find('#ticket-schedule-edit').modal()

  initializeDatepicker: (now) ->
    @$el.find('#ticket-schedule-on').datepicker(
      todayBtn: 'linked'
      autoclose: true
    )
    @$el.find('#schedule-at').modifiedwickedpicker(
      twentyFour: true
      now: now
    )

  onClickSetNewAppointment: (evt) ->
    @_warnTicketTabWillClose(@_setNewAppointment)

  _setNewAppointment: =>
    invalidFields = @_checkFieldsValidations()
    @toggleScheduleSpinner(true)
    return @showInvalidFields(invalidFields) if invalidFields.length
    $.ajax
      url: '/customer/ticket/schedule_ticket'
      type: 'POST'
      data: @_dataForScheduling()
      success: (response) =>
        @$el.find('#ticket-new-schedule').modal('hide')
        @_scheduleAppointment(response)
      error: (response) =>
        response.skipAttributesErrorDetail = true
        @trigger('ticket:saved:error', response)
        @toggleScheduleSpinner(false)
        console.log 'Error scheduling ticket appointment'

  toggleScheduleSpinner: (active) =>
    @$el.find('#cancel-new-schedule').attr('disabled', active)
    @$el.find('#set-new-schedule').attr('disabled', active)
    if active then @$el.find('#set-new-schedule-spinner').addClass('fa-spinner') else @$el.find('#set-new-schedule-spinner').removeClass('fa-spinner')
    if active then @$el.find('#set-new-schedule-spinner').addClass('fa-spin') else @$el.find('#set-new-schedule-spinner').removeClass('fa-spin')

  _warnTicketTabWillClose: (callback) =>
    swal
      title: I18n.t('customer.dashboard.conversations.details.scheduling.schedule_will_close')
      text: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.description')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.confirm')
      cancelButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.cancel')
      closeOnConfirm: true
      callback

  _scheduleAppointment: (response) =>
    @ticket.updateUserAppointment(JSON.parse(response.appointment))
    console.log 'Scheduled ticket appointment'
    @trigger('create:schedule', response.ticket_status, response.ticket_lock_version)
    @trigger('disable:schedule', false)
    @trigger('ticket:tab:closeRequired')

  onClickSetUpdatedAppointment: ->
    invalidFields = @_checkFieldsValidations()
    return @showInvalidFields(invalidFields) if invalidFields.length
    @$el.find('#ticket-schedule-edit').modal('hide')
    $.ajax
      url: '/customer/ticket/update_schedule'
      type: 'POST'
      data: @_dataForScheduling()
      success: @_updateAppointment
      error: -> console.log 'Error updating ticket appointment'

  _updateAppointment: (response) =>
    @ticket.updateUserAppointment(JSON.parse(response.appointment))
    console.log 'Updated ticket appointment'
    @trigger('update:schedule', response.ticket_status, response.ticket_lock_version)
    @trigger('disable:schedule', false)

  onClickCancelAppointment: (evt) ->
    @trigger('disable:schedule', false)
    $('#schedule-at').val('')
    $('#ticket-schedule-on').prop('selected', () => this.defaultSelected)
    $('#ticket-schedule-note').val('')

  onClickDeleteAppointment: =>
    swal
      title: I18n.t('customer.dashboard.conversations.details.scheduling.delete_confirmation_msg')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('customer.dashboard.conversations.details.scheduling.y')
      cancelButtonText: I18n.t('customer.dashboard.conversations.details.scheduling.n')
      closeOnConfirm: true
      @_deleteAppointment

  _deleteAppointment: =>
    @$el.find('#ticket-schedule-edit').modal('hide')
    ticketAppointmentToDelete = @ticket.get('userAppointment')
    $.ajax
      url: '/customer/ticket/remove_appointment'
      type: 'POST'
      data: ticketAppointmentToDelete
      success: @_afterDeleteAppointment
      error: -> console.log 'Error deleting ticket appointment'

  _afterDeleteAppointment: (response) =>
    console.log 'Deleted ticket appointment'
    emptyAppointment = JSON.parse(response.appointment)
    @ticket.updateUserAppointment(emptyAppointment)
    @trigger('delete:schedule')
    @trigger('disable:schedule', false)

  onChangeTicketSchedule: (evt) ->
    $(evt.target).removeClass('invalid-field')

  showInvalidFields: (invalidFields) ->
    for fieldId in invalidFields
      showError(I18n.t('customer.dashboard.conversations.details.scheduling.schedule_must_be_valid'))
      $(fieldId).addClass('invalid-field')

  _dataForScheduling: ->
    date: @_appointmentDateString()
    time: @_appointmentTimeString()
    timezone: moment().format('Z')
    notes: $('#ticket-schedule-note').val()
    ticketId: @ticket.get('id')

  _checkFieldsValidations: ->
    invalidFields = []
    invalidFields.push('#ticket-schedule-on') unless @_appointmentDateValid()
    invalidFields.push('#schedule-at') unless @_appointedTimeValid()
    invalidFields

  _appointmentDateValid: ->
    @_appointmentDateWellFormatted() and @_appointmentDateIsFuture()

  _appointedTimeValid: ->
    @_appointmentTimeWellFormatted() and @_appointmentDatetimeIsFuture()

  _appointmentDateWellFormatted: ->
    /^20[1-9][0-9]-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test @_appointmentDateString()

  _appointmentDateIsFuture: ->
    now = moment()
    appointmentDate = moment @_appointmentDateString()
    appointmentDate.isSame(now.format('YYYY-MM-DD')) or appointmentDate.isAfter now

  _appointmentTimeWellFormatted: ->
    /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test @_appointmentTimeString()

  _appointmentDatetimeIsFuture: ->
    timezone = moment().format('Z')
    datetime = moment(@_appointmentDateString() + 'T' + @_appointmentTimeString() + timezone)
    now = moment()
    datetime.isAfter now

  _appointmentDateString: ->
    $('#ticket-schedule-on').val()

  _appointmentTimeString: ->
    $('#schedule-at').val().replace(/\s+/g, '')
